import { render } from "./ConfermaSocialMedia.vue?vue&type=template&id=b36faa9c&scoped=true"
import script from "./ConfermaSocialMedia.vue?vue&type=script&lang=js"
export * from "./ConfermaSocialMedia.vue?vue&type=script&lang=js"

import "./ConfermaSocialMedia.vue?vue&type=style&index=0&id=b36faa9c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36faa9c"]])

export default __exports__